export default __webpack_public_path__ + "static/media/footer1.fe47ba8f.svg";